import { useConnectivity } from '@/contexts/ConnectivityContext';

export function OfflineBanner() {
  const { isOnline } = useConnectivity();

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: '56px',
        left: 0,
        right: 0,
        zIndex: 99,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--spacing-8)',
        padding: 'var(--spacing-8) var(--spacing-16)',
        backgroundColor: 'var(--color-warning)',
        color: 'var(--color-text-inverse)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: 'var(--font-weight-medium)',
      }}
    >
      <span aria-hidden="true">📡</span>
      <span>Sem conexão</span>
    </div>
  );
}
